const THEME_STORAGE_KEY = "careforge-theme";
const THEME_ATTRIBUTE = "data-theme";
const DARK_THEME_VALUE = "dark";
const LIGHT_THEME_VALUE = "light";
const PREFERS_DARK_MEDIA_QUERY = "(prefers-color-scheme: dark)";

const shouldUseDarkTheme = (savedTheme, prefersDark) => {
  return savedTheme === DARK_THEME_VALUE || (!savedTheme && Boolean(prefersDark));
};

const getThemeBootstrapInlineScript = () => {
  const storageKey = JSON.stringify(THEME_STORAGE_KEY);
  const mediaQuery = JSON.stringify(PREFERS_DARK_MEDIA_QUERY);
  const themeAttribute = JSON.stringify(THEME_ATTRIBUTE);
  const darkTheme = JSON.stringify(DARK_THEME_VALUE);

  return `(function(){try{var savedTheme=localStorage.getItem(${storageKey});var prefersDark=window.matchMedia(${mediaQuery}).matches;if(savedTheme===${darkTheme}||(!savedTheme&&prefersDark)){document.documentElement.setAttribute(${themeAttribute},${darkTheme});}}catch(error){}})();`;
};

module.exports = {
  THEME_STORAGE_KEY,
  THEME_ATTRIBUTE,
  DARK_THEME_VALUE,
  LIGHT_THEME_VALUE,
  PREFERS_DARK_MEDIA_QUERY,
  shouldUseDarkTheme,
  getThemeBootstrapInlineScript,
};
